import React from "react";

/// Shared geometry for the centered main-app pages (Overview, Datasets,
/// Connections, Trash, Access). Every page's column is content-height and
/// optically centered, so navigating between them doesn't shift the layout.

/// Rows a list page shows before it scrolls. One value across pages so their
/// columns land in the same height band.
export const LIST_MAX_ROWS = 9;

/// The same cap as a CSS length, for lists whose items aren't one flat row each.
export const LIST_MAX_HEIGHT = `calc(var(--item-height) * ${LIST_MAX_ROWS})`;

/// Overview carries a hero and a create strip around its list, so its list gets
/// a shorter cap to keep the total column comparable.
/// Rows there are `--item-height` (2rem) tall.
export const OVERVIEW_LIST_ROWS = 8;

/// Access stacks the most above its list — a page title, the five connect cards,
/// and an intro paragraph — so its tokens get the shortest cap of the three. The
/// connect panel grows when a card is opened, so the columns only line up at rest.
export const ACCESS_LIST_ROWS = 5;

export const ACCESS_LIST_MAX_HEIGHT = `calc(var(--item-height) * ${ACCESS_LIST_ROWS})`;

/// Weighted spacers that optically center the column — slightly above centre,
/// which reads better than dead centre. They collapse to zero once the content
/// overflows and the page scrolls.
export const ColumnTopSpacer: React.FC = () => <div style={{ flexGrow: 42 }} />;
export const ColumnBottomSpacer: React.FC = () => (
  <div style={{ flexGrow: 58 }} />
);
